import { render } from "./TypeOfObjectSelection.vue?vue&type=template&id=b59df76a"
import script from "./TypeOfObjectSelection.vue?vue&type=script&lang=js"
export * from "./TypeOfObjectSelection.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__